import React, { useCallback, useEffect, useState } from 'react';

import _ from 'lodash';
import { useSelector } from 'react-redux';

import { surveys } from 'api/endpoints/survey';
import LayoutMain from 'components/layouts/LayoutMain';
import { ENUM_SURVEY_STATUS } from 'constants/enum';
import { OPTION_PAGINATION } from 'constants/index';
import { TEXT_SURVEY_LIST } from 'constants/string/texts';
import CreateOptions from 'pages/Survey/CreateSurvey/CreateOptions';
import Download from 'pages/Survey/Download/Download';
import SurveyListHeader from 'pages/Survey/List/SurveyHeader';
import SurveyListPagination from 'pages/Survey/List/SurveyPagination';
import SurveyListSearch from 'pages/Survey/List/SurveySearch';
import SurveyListTable from 'pages/Survey/List/SurveyTable';
import { convertToQueryString } from 'utils/helper';

const Survey = () => {
  const { me } = useSelector((state) => state.auth);

  const [options, setOptions] = useState({ keyword: null, ...OPTION_PAGINATION });
  const [sort, setSort] = useState([]);
  const [listSurveys, setListSurveys] = useState([]);
  const [loading, setLoading] = useState(false);

  // SEARCH
  const onChangeKeyword = (keyword) => {
    if (keyword !== options.keyword) {
      setOptions((prevState) => {
        return { ...prevState, keyword: keyword };
      });
    }
  };

  // PAGINATION
  const onPageChange = (e) => {
    if (e !== options.page) {
      setOptions((prevState) => {
        return { ...prevState, page: e };
      });
      return true;
    }
    return false;
  };

  // SORT
  const onSortChange = (e) => {
    setSort(() => e);
  };

  /**
   * @name handleSort
   * @returns {string[]}
   * @example ['title', '-updated_at']
   * @example ['-title', 'updated_at']
   */
  const handleSort = () => {
    return (
      sort.map((item) => {
        return item.desc ? `-${item.id}` : item.id;
      }) || []
    );
  };

  const handleGetSurveys = async () => {
    const sortHandle = handleSort();
    const queryString = convertToQueryString({ keyword: options.keyword, sort_by: sortHandle, page: options.page });
    setLoading(true);
    try {
      await surveys(queryString)
        .then((response) => {
          const totalPage = Math.ceil(response.total / response.page_size);
          const page = response.page > totalPage ? (totalPage === 0 ? 1 : totalPage) : options.page;

          setListSurveys(response?.data || []);
          setOptions((prevState) => {
            return {
              ...prevState,
              total: response.total,
              page_size: response.page_size,
              page: page,
            };
          });
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } catch {
      setLoading(false);
    }
  };

  // GET DATA
  const getSurveys = useCallback(async () => {
    if (me) {
      handleGetSurveys();
    }
  }, [options.page, options.keyword, sort, me]);

  useEffect(() => {
    getSurveys();
  }, [getSurveys]);

  return (
    <>
      <LayoutMain>
        <section id="question-list">
          <h1 className="text-2xl font-bold text-black/85">{TEXT_SURVEY_LIST.TITLE}</h1>
          <SurveyListHeader options={options} />
          <SurveyListSearch options={options} onSubmit={onChangeKeyword} />
          <div className={`w-full mt-4 ${options.total > 0 ? 'min-h-164.75' : ''}`}>
            <SurveyListTable
              data={listSurveys}
              setSort={onSortChange}
              reloadData={handleGetSurveys}
              sort={sort}
              page={options.page}
              keyword={options.keyword}
              isFilter={!!options.keyword}
              onPageChange={onPageChange}
            />
          </div>
          {options.total > 0 && <SurveyListPagination options={options} onPageChange={onPageChange} loading={loading} />}
        </section>
      </LayoutMain>
      <Download />
      <CreateOptions />
    </>
  );
};

export default React.memo(Survey);
